import React from "react";
import {
    Table,
    Tag,
    Tooltip,
    Button,
    Progress,
    Space
} from "antd";

import {
    EyeOutlined,
    CopyOutlined
} from "@ant-design/icons";

const RateLimitEventsTable = ({
    data = [],
    loading = false,
    totalElements = 0,
    pagination,
    onViewDetails,
    onPageChange
}) => {

    // helpers
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };

    const renderOutcomeTag = (outcome) => {

        let color = "default";

        if (outcome === "BLOCKED")
            color = "red";

        if (outcome === "ALLOWED")
            color = "green";

        if (outcome === "THROTTLED")
            color = "orange";

        return (
            <Tag color={color}>
                {outcome}
            </Tag>
        );
    };

    const renderTypeTag = (type) => {

        const color =
            type === "PATH"
                ? "blue"
                : "purple";

        return (
            <Tag color={color}>
                {type}
            </Tag>
        );
    };

    const renderRemainingBar = (record) => {

        const remaining =
            record.remainingPathRequests ?? 0;

        return (
            <Tooltip
                title={`Remaining: ${remaining}`}
            >
                <Progress
                    percent={remaining > 0 ? 100 : 0}
                    size="small"
                    status={
                        remaining === 0
                            ? "exception"
                            : "normal"
                    }
                    showInfo={false}
                />
            </Tooltip>
        );
    };

    // table columns
    const columns = [

        {
            title: "Client ID",
            dataIndex: "clientId",
            key: "clientId",
            width: 160,
            render: (clientId) => (

                <Space>

                    <Tooltip title={clientId}>
                        <span>
                            {clientId?.substring(0, 8)}...
                        </span>
                    </Tooltip>

                    <CopyOutlined
                        onClick={() =>
                            copyToClipboard(clientId)
                        }
                        style={{ cursor: "pointer" }}
                    />

                </Space>

            )
        },

        {
            title: "API Key",
            dataIndex: "apiKeyId",
            key: "apiKeyId",
            width: 160,
            render: (apiKeyId) => (

                <Tooltip title={apiKeyId}>
                    <span>
                        {apiKeyId?.substring(0, 8)}...
                    </span>
                </Tooltip>

            )
        },

        {
            title: "Path",
            dataIndex: "path",
            key: "path",
            width: 300,
            render: (path) => (

                <Tooltip title={path}>
                    <span
                        style={{
                            fontFamily: "monospace"
                        }}
                    >
                        {path.length > 40
                            ? `${path.substring(0, 40)}...`
                            : path}
                    </span>
                </Tooltip>

            )
        },

        {
            title: "Type",
            dataIndex: "type",
            key: "type",
            width: 120,
            render: renderTypeTag
        },

        {
            title: "Outcome",
            dataIndex: "outcome",
            key: "outcome",
            width: 140,
            render: renderOutcomeTag
        },

        // {
        //     title: "Remaining",
        //     key: "remaining",
        //     width: 160,
        //     render: (_, record) =>
        //         renderRemainingBar(record)
        // },

        {
            title: "Retry After",
            dataIndex: "retryAfter",
            key: "retryAfter",
            width: 150
        },

        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            width: 200,
            render: (date) => {

                if (!date)
                    return "-";

                const formatted =
                    new Date(date).toLocaleString();

                return formatted;
            }
        },

        {
            title: "Action",
            key: "action",
            width: 120,
            render: (_, record) => (

                <Button
                    icon={<EyeOutlined />}
                    size="small"
                    onClick={() =>
                        onViewDetails(record)
                    }
                >
                </Button>

            )
        }

    ];

    // row highlighting
    const rowClassName = (record) => {

        if (record.outcome === "BLOCKED")
            return "blocked-row";

        return "";

    };


    return (

        <Table
            rowKey="id"
            columns={columns}
            dataSource={data}
            loading={loading}
            rowClassName={rowClassName}
            pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: totalElements,
                showSizeChanger: true,
                onChange: onPageChange
            }}
            onRow={(record) => ({
                onClick: () => onViewDetails(record),
            })}

            scroll={{
                x: 1500
            }}
            className="custom-table"
            size="sm"
        />

    );

};

export default RateLimitEventsTable;